import { FaTrashCan } from "react-icons/fa6";
import { ModalOverlay } from "./modal_overlay";
import { modalAnim } from "../../components/modal_anim";
import { modalBoxStyle } from "../../components/modal_box_style";
import { useState } from "react";
import { WaDeviceService } from "../../../../../../services/WaDeviceService";

export const WaNumberDeleteModal = ({ data, openModal, setOpenModal, refreshData }) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);

        try {
            const response = await WaDeviceService.delete({ id: data?.id });

            if (response.data.status) {
                alert(response.data.message || "Device berhasil dihapus!");
                setOpenModal(false);
                refreshData();
            } else {
                alert(response.data.message || "Gagal menghapus device.");
            }
        } catch (error) {
            console.error("Error delete device:", error);
            let errorMessage = "Terjadi kesalahan pada server.";

            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            alert(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    if (!openModal) return null;

    return (
        <ModalOverlay onClose={() => !loading && setOpenModal(false)}>
            <style>{modalAnim}</style>
            <div
                className="relative w-full max-w-xs rounded-2xl p-6 shadow-2xl border"
                style={{
                    ...modalBoxStyle,
                    animation: "modalIn 0.25s ease-out",
                }}
            >
                <div className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-red-500/8 border border-red-500/15 flex items-center justify-center">
                        <FaTrashCan className="text-red-400 text-2xl" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-100 mb-2">
                        Hapus Device?
                    </h3>
                    <p className="text-sm text-slate-400 mb-1 leading-relaxed">
                        Hapus perangkat{" "}
                        <span className="text-white font-semibold">
                            {data?.number}
                        </span>{" "}
                        dari sistem?
                    </p>
                    <p className="text-[11px] text-red-400/70 mb-6">
                        Tindakan ini tidak dapat dibatalkan.
                    </p>
                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => !loading && setOpenModal(false)}
                            disabled={loading}
                            className="flex-1 px-4 py-2.5 rounded-xl text-xs font-semibold transition-all bg-slate-800 text-slate-300 hover:bg-slate-700 border border-slate-700 disabled:opacity-40 disabled:cursor-not-allowed"
                        >
                            Batal
                        </button>
                        <button
                            onClick={handleDelete}
                            disabled={loading}
                            className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-xs font-semibold transition-all bg-red-600 text-white hover:bg-red-500 disabled:opacity-40 disabled:cursor-not-allowed shadow-lg shadow-red-600/20"
                        >
                            {loading ? (
                                <>
                                    <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                    Menghapus...
                                </>
                            ) : (
                                "Ya, Hapus"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </ModalOverlay>
    );
};